import { ReactNode } from "react";

import styles from "./UserConfigurationSectionComponent.module.scss";

interface UserConfigurationSectionComponentProps {
    title: string;
    children?: ReactNode;
    className?: string;
    headerClassName?: string;
    headerActionLink?: JSX.Element;
}

function UserConfigurationSectionComponent(props: Readonly<UserConfigurationSectionComponentProps>): JSX.Element {
    return (
        <div className={`${styles.userConfigurationSection} ${props.className ?? ""}`}>
            <div className={`${styles.header}  ${props.headerClassName ?? ""}`}>
                <h3>{props.title}</h3>
                {props.headerActionLink}
            </div>
            <div className={styles.body}>
                {props.children}
            </div>
        </div>
    );
}

export { UserConfigurationSectionComponent };
